import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getJobs(payload) {
    const result = await axios.post(apiUrl + "/support/get/jobs",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function runJobs(payload) {
    const result = await axios.post(apiUrl + "/support/run/job",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const JobServices = {
    getJobs,
    runJobs
   
}